import React from "react";
import {
  PageHTML,
  ZWrapper,
} from '../../ui-components';
import styled from "styled-components";


const GridContacts = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'studio';
  @media ${({ theme }) => theme.device.mobile}{
    grid-template-columns: 1fr;
    grid-template-areas:
      'studio';
    text-align: center;
  }
`;

const StudioContacts = styled.div`
  grid-area: studio;
`;

const ManufacturingContacts = styled.div`
  grid-area: manufacturing;
`;

const TextContacts = styled.div`
  grid-area: text;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 250px;

  @media ${({ theme }) => theme.device.phone}{
    height: 250px;
  }
`


const ContactsGrid = ({ html, googleMapsZStudio }) => (

  <GridContacts>
    <StudioContacts>
      <ZWrapper>
        <Iframe
          frameBorder="0" allowFullScreen
          src={googleMapsZStudio}
        >
        </Iframe>
      </ZWrapper>

      <PageHTML dangerouslySetInnerHTML={{ __html: html[0] }} center />
    </StudioContacts>
    <TextContacts>
    </TextContacts>
  </GridContacts >
)

export default ContactsGrid;
